export enum ContentfulPageImageTitleTemplate {
  HERO = 'hero',
  PICTO = 'picto',
  LANDING_HERO = 'landing',
  LANDING_HERO_GOLD = 'landing-gold',
  LANDING_HERO_FOSFO = 'landing-fosfo',
  LANDING_HERO_OPS = 'landing-ops',
  REFRESH_PRODUCT = 'refresh product',
  REFRESH_LANDING = 'refresh landing',
  REFRESH_INFORMATIONAL = 'refresh-page-informationnelle',
  PODCAST = 'podcast',
}
